import * as THREE from "three"

// Vertex Shader: Standard, passes UVs
const vertexShader = `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`

// Fragment Shader: Handles texture, colormap, and tint
const fragmentShader = `
  uniform sampler2D baseTexture;
  uniform sampler2D colormapTexture; // Optional colormap
  uniform vec3 tintColor;          // Tint color (can be biome color or dye)
  uniform bool useColormap;        // Flag to use colormap
  uniform bool useTintColor;       // Flag to use tintColor
  varying vec2 vUv;

  void main() {
    vec4 baseColor = texture2D(baseTexture, vUv);

    // If base texture is fully transparent, discard
    if (baseColor.a < 0.01) {
      discard;
    }

    vec3 finalColor = baseColor.rgb;

    if (useColormap) {
      // Simplified colormap sampling: using a fixed portion of the colormap
      // A real implementation would use biome data to calculate colormap UVs
      vec4 mapColor = texture2D(colormapTexture, vec2(vUv.x * 0.1 + 0.45, vUv.y * 0.1 + 0.45)); // Example: sample middle-ish
      finalColor *= mapColor.rgb;
    }

    if (useTintColor) {
      finalColor *= tintColor;
    }

    gl_FragColor = vec4(finalColor, baseColor.a);
  }
`

export class MinecraftTintableMaterial extends THREE.MeshStandardMaterial {
  constructor({
    baseTexture,
    //colormapTexture,
    tintColor,
    //useColormap = false,
    //useTintColor = false,
    transparent = true,
    alphaTest,
    depthWrite,
    side = THREE.DoubleSide
  }: {
    baseTexture: THREE.Texture
    //colormapTexture?: THREE.Texture
    tintColor?: THREE.ColorRepresentation
    //useColormap?: boolean
    //useTintColor?: boolean
    transparent?: boolean
    alphaTest?: number,
    depthWrite?: boolean
    side?: THREE.Side
  }) {
    super({
      map: baseTexture,
      color: new THREE.Color(tintColor || 0xffffff).multiply(new THREE.Color(0xffffff)),
      /*uniforms: {
        baseTexture: { value: baseTexture },
        colormapTexture: { value: colormapTexture || null }, // Ensure null if not provided
        tintColor: { value: new THREE.Color(tintColor || 0xffffff) },
        useColormap: { value: useColormap && colormapTexture ? true : false },
        useTintColor: { value: useTintColor },
      },*/
      alphaTest,
      transparent,
      //vertexShader,
      //fragmentShader,
      side,
      depthWrite
    })
  }
}
